
import { CaseStudyTemplate } from '@/components/case-studies/CaseStudyTemplate';
import { faSearch, faBell, faLink } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

export default function FireDetectionCaseStudy() {
  const { t } = useTranslation();

  return (
    <CaseStudyTemplate
      id="fire"
      title={t('caseStudies.fire.title')}
      description={t('caseStudies.fire.description')}
      video="/Fire&Smoke.mp4"
      image="/images/case-studies/fire-detection-hero.jpg"
      problem={t('caseStudies.fire.problem')}
      solution={t('caseStudies.fire.solution')}
      results={t('caseStudies.fire.results')}
      features={[
        {
          title: t('caseStudies.fire.features[0].title'),
          description: t('caseStudies.fire.features[0].description'),
          icon: faSearch
        },
        {
          title: t('caseStudies.fire.features[1].title'),
          description: t('caseStudies.fire.features[1].description'),
          icon: faBell
        },
        {
          title: t('caseStudies.fire.features[2].title'),
          description: t('caseStudies.fire.features[2].description'),
          icon: faLink
        }
      ]}
      faqs={t('caseStudies.fire.faq', { returnObjects: true }) as Array<{id?: string, question: string, answer: string}>}
    />
  );
}
